import { Component, h, Prop, Event, EventEmitter } from '@stencil/core';
import { Customer } from '../../../globals/customer';
import { SiteConfig } from '../../../globals/site-config';
import { SubmitCartResponse } from '../../../utils/submit-cart';
import { CartReviewTranslation } from '../../../globals/translations';
import { pcDataLayer } from '../../../helpers';

@Component({
  tag: 'cart-review-state',
  styleUrl: './state-styles/cart-review-state.scss',
  shadow: false,
})
export class CartReviewState {
  @Prop() cartResponse: SubmitCartResponse;
  @Prop() approvalLimit: number;
  @Prop() retailerConfig: Partial<SiteConfig>;
  @Prop() deliveryCost: number;
  @Prop() translation: Partial<CartReviewTranslation>;

  @Event() updateCustomer: EventEmitter<Partial<Customer>>;
  @Event() continueClick: EventEmitter;

  render() {
    if (typeof this.cartResponse === 'undefined') {
      return;
    }

    const {
      totalRetailerFeeAmount,
      items,
      totalRetailerDeliveryFees: deliveryFees,
      leaseToOwnTotal,
      cashPrice,
      status,
      leaseCostToOwn,
      initialPaymentTax,
      retailerDeliveryFeesTax,
      merchantSubmittedTotalTax,
      periodicPaymentWithEstimatedTax,
    } = this.cartResponse;
    const { merchantDisplayName, merchantLogoUrl, defaultLogoUrl, minLeaseAmount, nonLeasableLimit } = this.retailerConfig;
    const fallbackImgUrl = merchantLogoUrl ? merchantLogoUrl : defaultLogoUrl;

    const itemsList = items.map(item => {
      return {
        type: item.isLeasable ? 'LeaseItem' : 'NonLeaseItem',
        imgUrl: item?.imgUrl,
        description: item.identifier,
        model: item.description,
        priceEach: item.unitPrice,
        quantity: item.quantity,
      };
    });

    if (deliveryFees) {
      itemsList.push({
        type: 'NonLeaseItem',
        imgUrl: fallbackImgUrl,
        description: '',
        model: 'Delivery cost (Shipping)',
        priceEach: deliveryFees,
        quantity: 1,
      });
    }

    let salesTax = 0;

    items.forEach(item => (salesTax += item.tax));

    const cartReviewProps = {
      leasableTotal: leaseCostToOwn,
      remainingApproval: status === 'CART_OVER_APPROVAL' ? this.approvalLimit : this.approvalLimit - cashPrice,
      nonLeasableTotal: totalRetailerFeeAmount,
      itemsList,
      delivery: !deliveryFees ? this.deliveryCost : null,
      fallbackItemImgUrl: fallbackImgUrl,
      leaseToOwnTotal,
      salesTax: merchantSubmittedTotalTax ? merchantSubmittedTotalTax : salesTax,
      initialPaymentTax,
      retailerDeliveryFeesTax,
      status,
      showBack: false,
      minLeaseAmount,
      paymentsNumber: this.cartResponse.numberOfRecurringPayments,
      recurringPayment: this.cartResponse.periodicPayment,
      frequency: this.cartResponse.paymentFrequency,
      nonLeasableLimit,
      recurringPaymentWithTax: periodicPaymentWithEstimatedTax,
      translation: this.translation,
      merchantDisplayName,
    };

    if (status !== 'CART_SUCCESS') {
      pcDataLayer.gtmErrorGeneric(status, status);
    }

    return <pc-cart-review {...cartReviewProps} />;
  }
}
